import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { loginUser } from "../Store/user/userSlice";
import {
  loadRememberedLogin,
  saveRememberedLogin,
  clearRememberedLogin,
  setRememberMePreference,
} from "../utils/rememberLogin";

import styles from "../styles/User.module.scss";
import PasswordField from "./PasswordField";

const UserLoginForm = ({ toggleCurrentFormType, closeForm }) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const saved = loadRememberedLogin();
    setValues({
      email: saved.email,
      password: saved.password,
    });
    setRememberMe(saved.rememberMe);
  }, []);

  const handleChange = ({ target: { value, name } }) => {
    setValues((prev) => {
      const next = { ...prev, [name]: value };
      if (rememberMe && next.email && next.password) {
        saveRememberedLogin(next);
      }
      return next;
    });
    setError("");
  };

  const handleRememberMeChange = (e) => {
    const checked = e.target.checked;
    setRememberMe(checked);
    setRememberMePreference(checked);
    if (checked && values.email && values.password) {
      saveRememberedLogin(values);
    }
    if (!checked) {
      clearRememberedLogin();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!values.email || !values.password) {
      setError("Введіть email і пароль");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await dispatch(loginUser({ ...values, remember: rememberMe })).unwrap();

      if (rememberMe) {
        saveRememberedLogin(values);
      } else {
        clearRememberedLogin();
      }

      closeForm();
    } catch (err) {
      setError(typeof err === "string" ? err : "Невірний email або пароль");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.close} onClick={closeForm}>
        <svg className="icon">
          <use xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#close`} />
        </svg>
      </div>

      <div className={styles.title}>Авторизація</div>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.group}>
          <input
            type="email"
            placeholder="Ваш email"
            name="email"
            value={values.email}
            autoComplete="username"
            onChange={handleChange}
            required
          />
        </div>

        <div className={styles.group}>
          <PasswordField
            placeholder="Ваш пароль"
            name="password"
            value={values.password}
            autoComplete="current-password"
            onChange={handleChange}
            required
          />
        </div>

        <div className={styles.rememberMe}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={handleRememberMeChange}
              className={styles.checkbox}
            />
            <span className={styles.checkboxText}>Запам&apos;ятати мене</span>
          </label>
        </div>

        {error && <p className={styles.error}>{error}</p>}

        <div
          onClick={() => toggleCurrentFormType("signup")}
          className={styles.link}
        >
          Зареєструватися
        </div>

        <button type="submit" className={styles.submit} disabled={loading}>
          {loading ? "Вхід…" : "Вхід до кабінету"}
        </button>
      </form>
    </div>
  );
};

export default UserLoginForm;
